import {Encoder} from "./encoder";
import {Box} from "./box";
import {BoxService} from "./box-service";

export class Navigation {
    private readonly _encoder: Encoder;

    private readonly _boxService: BoxService;

    public constructor(encoder: Encoder, boxService: BoxService) {
        this._encoder = encoder;
        this._boxService = boxService;
    }

    public encodeBoxes(boxes: Box[]) {
        let queryString = ""

        for (let box of boxes) {
            const konvaBox = this._boxService.getKonvaBox(box);

            if (konvaBox) {
                queryString = queryString
                  + this.getApproximation(konvaBox.attrs.x)
                  + ":" + this.getApproximation(konvaBox.attrs.y)
                  + ":" + box.getSize()
                  + ":" + this._encoder.encodeDoor(box)
                  + ":" + this._encoder.encodeBack(box)
                  + ":" + this._encoder.encodeShelf(box)
                  + ":" + this._encoder.encodeDrawers(box)
                  + ":" + this._encoder.encodeCornerDirection(box)
                  + ":" + this._encoder.encodeCrossDivider(box)
                  + ";";
            }
        }

        return queryString;
    }

    public decodeBoxes(queryString) {
        let boxesStrings = queryString.split(";");

        let boxes = [];

        for (let box of boxesStrings) {

            let boxProps = box.split(":");

            if (boxProps.length === 7 || boxProps.length === 8 || boxProps.length === 9) {
                let box = {
                    x: Number(boxProps[0]),
                    y: Number(boxProps[1]),
                    size: boxProps[2],
                    door: boxProps[3],
                    back: boxProps[4],
                    shelf: boxProps[5],
                    drawers: boxProps[6],
                    direction: boxProps[7],
                    crossDivider: boxProps[8]
                };

                boxes.push(box);
            }
        }

        return boxes;
    }

    private getApproximation(val) {
        //return Math.round(val);
        return +val.toFixed(1);
    }
}
